import React from 'react';
import { ArchivingJobExperimentStatusDto } from 'business/models/Models';
import { CustomTableColumns, ETableFilterTypes } from '../controls/constants';

export type ArchivedTask = {
  id: number;
  name: string;
  dateArchived: string;
  experimentCount: number;
  location: string;
};

export type UnarchivePreviewRow = {
  id: number;
  name: string;
  fileLocation: string;
  dateCreated: string;
  lastInspectionDate: string;
  dateArchived: string;
  status: string;
};

export type UnarchiveResultRow = {
  name: string;
  fileLocation: string;
  dateCreated: string;
  lastInspectionDate: string;
  dateRestored: string;
  status: string;
};

export type ArchivedTasksListProps = {
  selectedTaskIds: number[];
  setSelectedTaskIds: React.Dispatch<React.SetStateAction<number[]>>;
  disabled?: boolean;
};

export enum EUnarchivePreviewTab {
  Preview = 0,
  Results = 1,
}

export type UnarchivePreviewProps = {
  selectedTaskIds: number[];
  selectedTab: number;
  onSelectedTabChange: (tab: number) => void;
  resultsJobId?: string | null;
  onUnarchiveSuccess?: () => void;
};

export type UnarchiveTableProps = {
  selectedTaskIds: number[];
  onUnarchiveSuccess?: () => void;
};

export const UNARCHIVE_PREVIEW_ROWS_PER_PAGE = 13;

export const UNARCHIVING_ERROR_FALLBACK_MESSAGE =
  'An error occurred while restoring the experiment data.';

export const UnarchivePreviewColumns: CustomTableColumns[] = [
  {
    key: 'name',
    title: 'Experiment Name',
    className: 'w-[24%] max-w-[24%]',
    filterType: ETableFilterTypes.Text,
  },
  {
    key: 'fileLocation',
    title: 'File Location',
    className: 'w-[24%] max-w-[24%]',
    filterType: ETableFilterTypes.Text,
  },
  {
    key: 'dateCreated',
    title: 'Date Created',
    className: 'w-[14%] max-w-[14%]',
    filterType: ETableFilterTypes.Date,
  },
  {
    key: 'lastInspectionDate',
    title: 'Last Inspection Date',
    className: 'w-[14%] max-w-[14%]',
    filterType: ETableFilterTypes.Date,
  },
  {
    key: 'dateArchived',
    title: 'Date Archived',
    className: 'w-[14%] max-w-[14%]',
    filterType: ETableFilterTypes.Date,
  },
  {
    key: 'status',
    title: 'Status',
    className: 'w-[10%] max-w-[10%]',
    filterType: ETableFilterTypes.Text,
  },
];

export const UnarchiveResultsColumns: CustomTableColumns[] = [
  {
    key: 'name',
    title: 'Experiment Name',
    className: 'w-[24%] max-w-[24%]',
    filterType: ETableFilterTypes.Text,
  },
  {
    key: 'fileLocation',
    title: 'File Location',
    className: 'w-[24%] max-w-[24%]',
    filterType: ETableFilterTypes.Text,
  },
  {
    key: 'dateCreated',
    title: 'Date Created',
    className: 'w-[14%] max-w-[14%]',
    filterType: ETableFilterTypes.Date,
  },
  {
    key: 'lastInspectionDate',
    title: 'Last Inspection Date',
    className: 'w-[14%] max-w-[14%]',
    filterType: ETableFilterTypes.Date,
  },
  {
    key: 'dateRestored',
    title: 'Date Restored',
    className: 'w-[14%] max-w-[14%]',
    filterType: ETableFilterTypes.Date,
  },
  {
    key: 'status',
    title: 'Status',
    className: 'w-[10%] max-w-[10%]',
    filterType: ETableFilterTypes.Text,
  },
];
